import { getStore } from '../store/SharePointItemsViewNavigationLocationStore';

export function getSharePointItemsViewIsAtRootLevel(groupSmtpAddress: string): boolean {
    groupSmtpAddress = groupSmtpAddress.toLowerCase();
    const store = getStore();
    if (store.has(groupSmtpAddress)) {
        const path = store.get(groupSmtpAddress).currentPath;
        return !(path && path.length > 0 && path !== '/');
    }

    // No stored path implies user hasnt navigated anywhere and is therefore at the root
    return true;
}
